import React, { useState } from "react";
import "./panel.scss";
import SiteTexts from "utils/Texts";
import { Labels } from "utils/Labels";
import TextInput from "components/Input/TextInput";
import { onlyNumber } from "utils/rejex";
import DefaultSelectInput from "components/SelectInput/SelectInput";
import { ErrorAddProperty } from "JsFunctions/Dashboard/AddProperty";
import CheckBoxInput from "components/CheckBoxInput/CheckBoxInput";
import TextArea from "components/TextArea/TextArea";
import Map from "components/Map/map";
import { defaultLocationType } from "components/Map/map";
import { baseURL } from "API/Axios";
import { Addresses } from "utils/Addresses";
import CustomModal from "components/Modal/CustomModal";
import TextEditor from "components/TextEditor/TextEditor";

interface Props {
  data: any;
  dataGot: boolean;
  editPropertyHandler: () => void;
  error: ErrorAddProperty;
  setAdvisor: React.Dispatch<React.SetStateAction<string>>;
  landlord: string;
  setLandlord: React.Dispatch<React.SetStateAction<string>>;
  phone: string;
  setPhone: React.Dispatch<React.SetStateAction<string>>;
  mobile: string;
  setMobile: React.Dispatch<React.SetStateAction<string>>;
  setRegion: React.Dispatch<React.SetStateAction<string>>;
  address: string;
  setAddress: React.Dispatch<React.SetStateAction<string>>;
  setProperty: React.Dispatch<React.SetStateAction<string>>;
  shopCenter: string;
  setShopCenter: React.Dispatch<React.SetStateAction<string>>;
  unitInFloor: string;
  setUnitInFloor: React.Dispatch<React.SetStateAction<string>>;
  floor: string;
  setFloor: React.Dispatch<React.SetStateAction<string>>;
  numOfFloors: string;
  setNumOfFloors: React.Dispatch<React.SetStateAction<string>>;
  area: string;
  setArea: React.Dispatch<React.SetStateAction<string>>;
  bed: string;
  setBed: React.Dispatch<React.SetStateAction<string>>;
  bath: string;
  setBath: React.Dispatch<React.SetStateAction<string>>;
  buildingAge: string;
  setBuildingAge: React.Dispatch<React.SetStateAction<string>>;
  renovated: boolean;
  setRenovated: React.Dispatch<React.SetStateAction<boolean>>;
  descriptionAboutThisProperty: string;
  setDescriptionAboutThisProperty: React.Dispatch<React.SetStateAction<string>>;
  fullFurnished: boolean;
  setFullFurnished: React.Dispatch<React.SetStateAction<boolean>>;
  semiFurnished: boolean;
  setSemiFurnished: React.Dispatch<React.SetStateAction<boolean>>;
  monthlyRent: string;
  setMonthlyRent: React.Dispatch<React.SetStateAction<string>>;
  setKitchen: React.Dispatch<React.SetStateAction<string>>;
  setFloorCover: React.Dispatch<React.SetStateAction<string>>;
  telLine: string;
  setTelLine: React.Dispatch<React.SetStateAction<string>>;
  advertisement: boolean;
  setAdvertisement: React.Dispatch<React.SetStateAction<boolean>>;
  storage: boolean;
  setStorage: React.Dispatch<React.SetStateAction<boolean>>;
  firePlace: boolean;
  setFirePlace: React.Dispatch<React.SetStateAction<boolean>>;
  seoDescription: string;
  setSeoDescription: React.Dispatch<React.SetStateAction<string>>;
  seoTitle: string;
  setSeoTitle: React.Dispatch<React.SetStateAction<string>>;
  setLocation: React.Dispatch<React.SetStateAction<any>>;
  location: defaultLocationType;
  facility: any;
  facilityChangeCustom: (id: number) => void;
  forceUpdate: number;
  advisor: string;
  region: string;
  property: string;
  kitchen: string;
  floorCover: string;
  selectedPropertyStatus: string;
  statusList: any;
  changePropertyStatus: any;
  uploadImageFunc: (e: any) => void;
  showImageArrey: any;
  sortImage: (e: any, key: number) => void;
  forceUpdateShowImageArrey: boolean;
  removeImageFunc: (sortNumber: number) => void;
  garageCount: string;
  setGarageCount: React.Dispatch<React.SetStateAction<string>>;
  isItHotProperty: boolean;
  setIsItHotProperty: React.Dispatch<React.SetStateAction<boolean>>;
  monthlyRentAfter: string;
  setMonthlyRentAfter: React.Dispatch<React.SetStateAction<string>>;
}

const AddEditPropertyPage: React.FC<Props> = ({
  data,
  dataGot,
  editPropertyHandler,
  error,
  setAdvisor,
  landlord,
  setLandlord,
  phone,
  setPhone,
  mobile,
  setMobile,
  setRegion,
  address,
  setAddress,
  setProperty,
  shopCenter,
  setShopCenter,
  unitInFloor,
  setUnitInFloor,
  floor,
  setFloor,
  numOfFloors,
  setNumOfFloors,
  area,
  setArea,
  bed,
  setBed,
  bath,
  setBath,
  buildingAge,
  setBuildingAge,
  renovated,
  setRenovated,
  descriptionAboutThisProperty,
  setDescriptionAboutThisProperty,
  fullFurnished,
  setFullFurnished,
  semiFurnished,
  setSemiFurnished,
  monthlyRent,
  setMonthlyRent,
  setKitchen,
  setFloorCover,
  telLine,
  setTelLine,
  advertisement,
  setAdvertisement,
  storage,
  setStorage,
  firePlace,
  setFirePlace,
  seoDescription,
  setSeoDescription,
  seoTitle,
  setSeoTitle,
  setLocation,
  location,
  facility,
  facilityChangeCustom,
  forceUpdate,
  advisor,
  region,
  property,
  kitchen,
  floorCover,
  selectedPropertyStatus,
  statusList,
  changePropertyStatus,
  uploadImageFunc,
  showImageArrey,
  sortImage,
  forceUpdateShowImageArrey,
  removeImageFunc,
  garageCount,
  setGarageCount,
  isItHotProperty,
  setIsItHotProperty,
  monthlyRentAfter,
  setMonthlyRentAfter,
}) => {
  const [showModal, setShowModal] = useState<boolean>(false);
  const [imageSelected, setImageSelected] = useState<string>("");
  const SiteText = SiteTexts();

  return (
    <>
      <div className="add-property-parent">
        <h4>{SiteText.ADD_PROPERTY.EDIT_PROPERTY}</h4>
        {dataGot ? (
          <form onSubmit={editPropertyHandler}>
            <section>
              <h6>{SiteText.ADD_PROPERTY.PROPERTY_STATUS}</h6>
              <div className="inputs-parent">
                <div className="text-input-parent">
                  <DefaultSelectInput
                    lable={Labels.InputLabels.Status}
                    className={"general-select-input"}
                    error={""}
                    required={true}
                    name={"inpute-status"}
                    onChangeValue={changePropertyStatus}
                    list={statusList}
                    defaultValue={selectedPropertyStatus.toString()}
                  />
                </div>
              </div>
            </section>
            <section>
              <h6>{SiteText.ADD_PROPERTY.AGENCY_DETAILS}</h6>
              <div className="inputs-parent">
                <div className="text-input-parent">
                  <DefaultSelectInput
                    lable={Labels.InputLabels.Advisor}
                    className={
                      "general-select-input" + (error.advisor ? " error" : "")
                    }
                    error={error.advisor}
                    required={true}
                    name={"inpute-advisor"}
                    onChangeValue={setAdvisor}
                    list={data.listAdvisor}
                    defaultValue={advisor}
                  />
                </div>
              </div>
            </section>
            <section>
              <h6>{SiteText.ADD_PROPERTY.OWNER_DETAILS}</h6>
              <div className="inputs-parent">
                <div className="text-input-parent">
                  <TextInput
                    lable={Labels.InputLabels.Landlord}
                    className={
                      "general-select-input" + (error.landlord ? " error" : "")
                    }
                    error={error.landlord}
                    required={true}
                    name={"inpute-landlord"}
                    value={landlord}
                    onChangeValue={setLandlord}
                    autoFocus={false}
                    regex={""}
                    type={"text"}
                    removeLable={false}
                    maxlength={80}
                  />
                </div>
                <div className="text-input-parent">
                  <TextInput
                    lable={Labels.InputLabels.Phone}
                    className={
                      "general-select-input" + (error.phone ? " error" : "")
                    }
                    error={error.phone}
                    required={true}
                    name={"inpute-Phone"}
                    value={phone}
                    onChangeValue={setPhone}
                    autoFocus={false}
                    regex={onlyNumber}
                    type={"tel"}
                    removeLable={false}
                    maxlength={12}
                  />
                </div>
                <div className="text-input-parent">
                  <TextInput
                    lable={Labels.InputLabels.Mobile}
                    className={
                      "general-select-input" + (error.mobile ? " error" : "")
                    }
                    error={error.mobile}
                    required={true}
                    name={"inpute-mobile"}
                    value={mobile}
                    onChangeValue={setMobile}
                    autoFocus={false}
                    regex={onlyNumber}
                    type={"tel"}
                    removeLable={false}
                    maxlength={11}
                  />
                </div>
              </div>
            </section>
            <section>
              <h6>{SiteText.ADD_PROPERTY.REGION_DETAILS}</h6>
              <div className="inputs-parent">
                <div className="text-input-parent">
                  <DefaultSelectInput
                    lable={Labels.InputLabels.Region}
                    className={
                      "general-select-input" + (error.region ? " error" : "")
                    }
                    error={error.region}
                    required={true}
                    name={"inpute-region"}
                    onChangeValue={setRegion}
                    list={data.listRegion}
                    defaultValue={region}
                  />
                </div>
                <div className="text-input-parent width65">
                  <TextInput
                    lable={Labels.InputLabels.Address}
                    className={
                      "general-select-input" + (error.address ? " error" : "")
                    }
                    error={error.address}
                    required={true}
                    name={"inpute-address"}
                    value={address}
                    onChangeValue={setAddress}
                    autoFocus={false}
                    regex={""}
                    type={"text"}
                    removeLable={false}
                    maxlength={200}
                  />
                </div>
              </div>
            </section>
            <section>
              <h6>{SiteText.ADD_PROPERTY.DETAILS}</h6>
              <div className="inputs-parent">
                <div className="text-input-parent">
                  <DefaultSelectInput
                    lable={Labels.InputLabels.PropertyType}
                    className={
                      "general-select-input" + (error.property ? " error" : "")
                    }
                    error={error.property}
                    required={true}
                    name={"inpute-property"}
                    onChangeValue={setProperty}
                    list={data.listPropertys}
                    defaultValue={property}
                  />
                </div>
                <div className="text-input-parent">
                  <TextInput
                    lable={Labels.InputLabels.ShopCenter}
                    className={"general-select-input"}
                    error={""}
                    required={false}
                    name={"inpute-shop-center"}
                    value={shopCenter}
                    onChangeValue={setShopCenter}
                    autoFocus={false}
                    regex={onlyNumber}
                    type={"tel"}
                    removeLable={false}
                    maxlength={80}
                  />
                </div>
                <div className="text-input-parent">
                  <TextInput
                    lable={Labels.InputLabels.UnitInFloor}
                    className={
                      "general-select-input" +
                      (error.unitInFloor ? " error" : "")
                    }
                    error={error.unitInFloor}
                    required={true}
                    name={"inpute-unit-in-floor"}
                    value={unitInFloor}
                    onChangeValue={setUnitInFloor}
                    autoFocus={false}
                    regex={onlyNumber}
                    type={"tel"}
                    removeLable={false}
                    maxlength={80}
                  />
                </div>
                <div className="text-input-parent">
                  <TextInput
                    lable={Labels.InputLabels.Floor}
                    className={
                      "general-select-input" + (error.floor ? " error" : "")
                    }
                    error={error.floor}
                    required={true}
                    name={"inpute-floor"}
                    value={floor}
                    onChangeValue={setFloor}
                    autoFocus={false}
                    regex={onlyNumber}
                    type={"tel"}
                    removeLable={false}
                    maxlength={80}
                  />
                </div>
                <div className="text-input-parent">
                  <TextInput
                    lable={Labels.InputLabels.NumOfFloors}
                    className={
                      "general-select-input" +
                      (error.numOfFloors ? " error" : "")
                    }
                    error={error.numOfFloors}
                    required={true}
                    name={"inpute-num-of-floors"}
                    value={numOfFloors}
                    onChangeValue={setNumOfFloors}
                    autoFocus={false}
                    regex={onlyNumber}
                    type={"tel"}
                    removeLable={false}
                    maxlength={80}
                  />
                </div>
                <div className="text-input-parent">
                  <TextInput
                    lable={Labels.InputLabels.Area}
                    className={
                      "general-select-input" + (error.area ? " error" : "")
                    }
                    error={error.area}
                    required={true}
                    name={"inpute-area"}
                    value={area}
                    onChangeValue={setArea}
                    autoFocus={false}
                    regex={onlyNumber}
                    type={"tel"}
                    removeLable={false}
                    maxlength={80}
                  />
                </div>
                <div className="text-input-parent">
                  <TextInput
                    lable={Labels.InputLabels.Beds}
                    className={
                      "general-select-input" + (error.bed ? " error" : "")
                    }
                    error={error.bed}
                    required={true}
                    name={"inpute-bed"}
                    value={bed}
                    onChangeValue={setBed}
                    autoFocus={false}
                    regex={onlyNumber}
                    type={"tel"}
                    removeLable={false}
                    maxlength={80}
                  />
                </div>
                <div className="text-input-parent">
                  <TextInput
                    lable={Labels.InputLabels.Baths}
                    className={
                      "general-select-input" + (error.bath ? " error" : "")
                    }
                    error={error.bath}
                    required={true}
                    name={"inpute-bath"}
                    value={bath}
                    onChangeValue={setBath}
                    autoFocus={false}
                    regex={onlyNumber}
                    type={"tel"}
                    removeLable={false}
                    maxlength={80}
                  />
                </div>
                <div className="text-input-parent">
                  <TextInput
                    lable={Labels.InputLabels.BuildingAge}
                    className={
                      "general-select-input" +
                      (error.buildingAge ? " error" : "")
                    }
                    error={error.buildingAge}
                    required={true}
                    name={"inpute-buildingAge"}
                    value={buildingAge}
                    onChangeValue={setBuildingAge}
                    autoFocus={false}
                    regex={onlyNumber}
                    type={"tel"}
                    removeLable={false}
                    maxlength={80}
                  />
                </div>
                <div className="text-input-parent width100">
                  <TextEditor
                    setValue={setDescriptionAboutThisProperty}
                    value={descriptionAboutThisProperty}
                    lable={Labels.InputLabels.DescriptionProperty}
                    required={false}
                    removeLable={false}
                  />
                </div>
                <div className="text-input-parent">
                  <CheckBoxInput
                    lableText={Labels.InputLabels.Renovated}
                    className={
                      !renovated
                        ? "general-checkbox-input"
                        : "general-checkbox-input checked"
                    }
                    onChangeFunction={setRenovated}
                    value={renovated}
                  />
                </div>
                <div className="text-input-parent">
                  <CheckBoxInput
                    lableText={Labels.InputLabels.FullFurnished}
                    className={
                      !fullFurnished
                        ? "general-checkbox-input"
                        : "general-checkbox-input checked"
                    }
                    onChangeFunction={setFullFurnished}
                    value={fullFurnished}
                  />
                </div>
                <div className="text-input-parent">
                  <CheckBoxInput
                    lableText={Labels.InputLabels.SemiFurnished}
                    className={
                      !semiFurnished
                        ? "general-checkbox-input"
                        : "general-checkbox-input checked"
                    }
                    onChangeFunction={setSemiFurnished}
                    value={semiFurnished}
                  />
                </div>
              </div>
            </section>
            <section>
              <h6>{SiteText.ADD_PROPERTY.PEYMENT_DETAILS}</h6>
              <div className="inputs-parent">
                <div className="text-input-parent">
                  <TextInput
                    lable={Labels.InputLabels.MonthlyRent}
                    className={
                      "general-select-input" +
                      (error.monthlyRent ? " error" : "")
                    }
                    error={error.monthlyRent}
                    required={true}
                    name={"inpute-monthly-rent"}
                    value={monthlyRent}
                    onChangeValue={setMonthlyRent}
                    autoFocus={false}
                    regex={onlyNumber}
                    type={"tel"}
                    removeLable={false}
                    maxlength={80}
                  />
                </div>
                <div className="text-input-parent"></div>
                <div className="text-input-parent"></div>
                <div className="text-input-parent">
                  <CheckBoxInput
                    lableText={Labels.InputLabels.HotProperty}
                    className={
                      !isItHotProperty
                        ? "general-checkbox-input"
                        : "general-checkbox-input checked"
                    }
                    onChangeFunction={setIsItHotProperty}
                    value={isItHotProperty}
                    marginTop={"19px"}
                  />
                </div>
                {isItHotProperty ? (
                  <div className="text-input-parent">
                    <TextInput
                      lable={Labels.InputLabels.MonthlyrentAfterDiscount}
                      className={"general-select-input"}
                      error={""}
                      required={false}
                      name={"inpute-monthly-rent-after"}
                      value={monthlyRentAfter}
                      onChangeValue={setMonthlyRentAfter}
                      autoFocus={false}
                      regex={onlyNumber}
                      type={"tel"}
                      removeLable={false}
                      maxlength={80}
                    />
                  </div>
                ) : (
                  <></>
                )}
                <div className="text-input-parent"></div>
              </div>
            </section>
            <section>
              <h6>{SiteText.ADD_PROPERTY.MAIN_FEATURES}</h6>
              <div className="inputs-parent">
                <div className="text-input-parent">
                  <DefaultSelectInput
                    lable={Labels.InputLabels.Kitchen}
                    className={
                      "general-select-input" + (error.kitchen ? " error" : "")
                    }
                    error={error.kitchen}
                    required={true}
                    name={"inpute-kitchen"}
                    onChangeValue={setKitchen}
                    list={data.listKitchenService}
                    defaultValue={kitchen}
                  />
                </div>
                <div className="text-input-parent">
                  <DefaultSelectInput
                    lable={Labels.InputLabels.FloorCover}
                    className={
                      "general-select-input" +
                      (error.floorCover ? " error" : "")
                    }
                    error={error.floorCover}
                    required={true}
                    name={"inpute-floorCover"}
                    onChangeValue={setFloorCover}
                    list={data.listFloorCover}
                    defaultValue={floorCover}
                  />
                </div>
                <div className="text-input-parent">
                  <TextInput
                    lable={Labels.InputLabels.TelLine}
                    className={
                      "general-select-input" + (error.telLine ? " error" : "")
                    }
                    error={error.telLine}
                    required={true}
                    name={"inpute-telLine"}
                    value={telLine}
                    onChangeValue={setTelLine}
                    autoFocus={false}
                    regex={onlyNumber}
                    type={"tel"}
                    removeLable={false}
                    maxlength={80}
                  />
                </div>
                <div className="text-input-parent">
                  <TextInput
                    lable={Labels.InputLabels.GarageCount}
                    className={
                      "general-select-input" +
                      (error.garageCount ? " error" : "")
                    }
                    error={error.garageCount}
                    required={true}
                    name={"inpute-garage-count"}
                    value={garageCount}
                    onChangeValue={setGarageCount}
                    autoFocus={false}
                    regex={onlyNumber}
                    type={"tel"}
                    removeLable={false}
                    maxlength={80}
                  />
                </div>
                <div className="text-input-parent"></div>
                <div className="text-input-parent"></div>
                <div className="text-input-parent">
                  <CheckBoxInput
                    lableText={Labels.InputLabels.Advertisement}
                    className={
                      !advertisement
                        ? "general-checkbox-input"
                        : "general-checkbox-input checked"
                    }
                    onChangeFunction={setAdvertisement}
                    value={advertisement}
                  />
                </div>
                <div className="text-input-parent">
                  <CheckBoxInput
                    lableText={Labels.InputLabels.Storage}
                    className={
                      !storage
                        ? "general-checkbox-input"
                        : "general-checkbox-input checked"
                    }
                    onChangeFunction={setStorage}
                    value={storage}
                  />
                </div>
                <div className="text-input-parent">
                  <CheckBoxInput
                    lableText={Labels.InputLabels.FirePlace}
                    className={
                      !firePlace
                        ? "general-checkbox-input"
                        : "general-checkbox-input checked"
                    }
                    onChangeFunction={setFirePlace}
                    value={firePlace}
                  />
                </div>
              </div>
            </section>
            <section>
              <h6>{SiteText.ADD_PROPERTY.Additional_Features}</h6>
              <div style={{ display: "none" }}>{forceUpdate}</div>
              <div className="inputs-parent">
                {facility.map((item: any, key: any) => (
                  <div key={key} className="text-input-parent">
                    <CheckBoxInput
                      lableText={item.title}
                      className={
                        !item.status
                          ? "general-checkbox-input"
                          : "general-checkbox-input checked"
                      }
                      onChangeFunction={facilityChangeCustom}
                      value={item.status}
                      id={item.id}
                    />
                  </div>
                ))}
              </div>
            </section>
            <section>
              <h6>{SiteText.ADD_PROPERTY.SeoInformation}</h6>
              <div className="inputs-parent">
                <div className="text-input-parent width100">
                  <TextInput
                    lable={Labels.InputLabels.SeoTitle}
                    className={"general-select-input"}
                    error={""}
                    required={false}
                    name={"inpute-seo-title"}
                    value={seoTitle}
                    onChangeValue={setSeoTitle}
                    autoFocus={false}
                    regex={""}
                    type={"text"}
                    removeLable={false}
                    maxlength={80}
                  />
                </div>
                <div className="text-input-parent width100">
                  <TextArea
                    lable={Labels.InputLabels.SeoDescription}
                    className={"general-text-area-input"}
                    error={""}
                    required={false}
                    name={"inpute-seo-description"}
                    value={seoDescription}
                    onChangeValue={setSeoDescription}
                    autoFocus={false}
                    regex={""}
                    removeLable={false}
                    maxlength={500}
                  />
                </div>
              </div>
            </section>
            <section>
              <h6>{SiteText.ADD_PROPERTY.IMAGES}</h6>
              <div className="upload-image-guide">
                <ul>
                  {SiteText.ADD_PROPERTY.IMAGE_INSTRUCTIONS.map(
                    (text: string, key: number) => (
                      <li key={key}>{text}</li>
                    )
                  )}
                </ul>
              </div>
              <div className="inputs-parent">
                <div
                  style={{ position: "relative" }}
                  className="text-input-parent"
                >
                  <input
                    type="file"
                    className="upload-img-btn"
                    onChange={(e: any) => uploadImageFunc(e)}
                  />
                  <div className="upload-img-view">
                    {Labels.ButtonLabels.SELECT_IMAGE}
                  </div>
                </div>
              </div>
              <div className="property-images-parent">
                {forceUpdateShowImageArrey === true ? (
                  showImageArrey.map((item: any, key: number) => (
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        position: "relative",
                      }}
                      key={key}
                    >
                      <div className="image-position-parent">
                        <div
                          onClick={() => removeImageFunc(item.sort)}
                          className="delete-image-btn"
                          title="Remove Image"
                        >
                          <img src={Addresses.icons.CLOSE_MODAL_X_RED} />
                        </div>
                        <p>Image Sort: </p>
                        <input
                          key={key}
                          onChange={(e) => sortImage(e, key)}
                          onFocus={(e) => e.target.select()}
                          defaultValue={item.sort}
                          max={"30"}
                          min={"1"}
                          type="number"
                          onKeyDown={(e) => {
                            if (
                              e.code === "Enter" ||
                              e.code === "NumpadEnter"
                            ) {
                              e.preventDefault();
                            }
                          }}
                        />
                      </div>

                      <img
                        onClick={() => {
                          setShowModal(true);
                          setImageSelected(
                            typeof item.image === "string"
                              ? baseURL + item.image
                              : URL.createObjectURL(item.image)
                          );
                        }}
                        key={key}
                        alt="not found"
                        src={
                          typeof item.image === "string"
                            ? baseURL + item.image
                            : URL.createObjectURL(item.image)
                        }
                      />
                      {item.sort === 1 ? (
                        <p className="primary-image">Primary Image</p>
                      ) : (
                        <></>
                      )}
                    </div>
                  ))
                ) : (
                  <></>
                )}
              </div>
            </section>
            <section className="no-border">
              <h6>{SiteText.ADD_PROPERTY.Location}</h6>
              <div
                style={{
                  width: "100%",
                  overflow: "hidden",
                  borderRadius: "5px",
                }}
              >
                <Map changeMarker={setLocation} location={location} />
              </div>
            </section>
            <div className="submit-search-input-parent">
              <button onSubmit={editPropertyHandler}>
                {Labels.ButtonLabels.EDIT_PROPERTY}
              </button>
            </div>
          </form>
        ) : (
          <></>
        )}
      </div>
      <CustomModal
        showModal={showModal}
        close={() => setShowModal(false)}
        closeAble={true}
        maxWidth={"600px"}
      >
        <div style={{ width: "100%" }}>
          <img src={imageSelected} width={"100%"} />
        </div>
      </CustomModal>
    </>
  );
};

export default AddEditPropertyPage;
